import { AboutApplicationPage } from "./ui/abouApplication.page";

export default AboutApplicationPage;
